import { render, staticRenderFns } from "./list-element.vue?vue&type=template&id=372a7a8c&scoped=true&"
var script = {}
import style0 from "./list-element.vue?vue&type=style&index=0&id=372a7a8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a7a8c",
  null
  
)

export default component.exports